// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';

export const replySupportListRaw = (state: RootState) => state.replySupportReducer;

export const makeReplySupportSelector = () => {
  return createSelector(
    replySupportListRaw,
    (replySupportReducer) => replySupportReducer.data || {}
  );
}
export const makeReplySupportError = () => {
  return createSelector(
    replySupportListRaw,
    (replySupportReducer) => replySupportReducer.error
  );
}

export const makeReplySupportIsLoading = () => {
  return createSelector(
    replySupportListRaw,
    (replySupportReducer) => replySupportReducer.isLoading
  );
}
